/**
 * @deprecated
 */
import $ from 'jquery';
import {decorateInnerElements, disposeInnerComponents} from 'fg-frontend/src/webComponents/decorate';
import {set} from "ramda";

require('fg-frontend/plugins/jquery.universal-pagination');
var isMobile = require('ismobilejs');


/********************************************
 * stage list pagination
 *******************************************/
$(document).on('STAGE_PAGINATION_ACTIVATE', function () {
  $('.js_pagination-stage').each(function (index, item) {
    var $page = $(item);

    $page.universalPagination({
      listSelector: '.js_psList',
      itemSelector: '.js_psItem',
      lang: projectConfig.lang,
      nextClass: 'btn btn--primary',
      nextWrapperClass: 'buttons pagination--buttons',
      autoPreloadHistory: false,
      listTopOffset: 15,
      paginationSelector: '.js_pagination-stage',
      wrapperClass: 'pagination__wrapper'
    });
  });
}).on('ajaxComplete', function () {
  $(document).trigger('STAGE_PAGINATION_ACTIVATE');
  if ($('#js_mediaList').length) {
    decorateInnerElements(document.querySelector('#js_mediaList'));

    //Dynamický title Start
    let urlParams = (function (a) {
      if (a == '') return {};
      let b = {};
      for (let i = 0; i < a.length; ++i) {
        let p = a[i].split('=');
        if (p.length !== 2) continue;
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
      }
      return b;
    })(window.location.search.substr(1).split('&'));

    if ((urlParams['pageNumber']) && (document.getElementById('dynamicPageTitle')) && (document.querySelector('[data-page-name]'))) {
      // Titulek stránky
      const dynamicPageTitle = document.getElementById('dynamicPageTitle').getAttribute('data-dynamic-page-title');

      // Slovo "stránka"
      const documentPageTitle = document.querySelector('[data-page-name]').getAttribute('data-page-name');

      // Název Hasičovo
      const documentTitle = document.title;
      const documentTitleArray = documentTitle.split('-');
      const documentTitleLastInArray = documentTitleArray[documentTitleArray.length - 1].trim();

      let dynamicPageTitleArray = dynamicPageTitle.split('-');

      if (document.getElementById('dynamicPageTitleNumber')) {
        dynamicPageTitleArray.splice(1, 1, urlParams['pageNumber'] + '.' + documentPageTitle);
        document.getElementById('dynamicPageTitleNumber').innerText = urlParams['pageNumber'];

        if (document.getElementById('dynamicPagePerexNumber')) {
          document.getElementById('dynamicPagePerexNumber').innerText = urlParams['pageNumber'];
        }
      } else {
        dynamicPageTitleArray.splice(1, 0, urlParams['pageNumber'] + '.' + documentPageTitle);
        document.getElementById('dynamicPageTitle').innerText = dynamicPageTitleArray.join(' - ');

        if (document.getElementById('dynamicPagePerex')) {
          // Perex stránky
          const dynamicPagePerex = document.getElementById('dynamicPagePerex').getAttribute('data-dynamic-page-perex');
          const dynamicPagePerexArray = dynamicPagePerex.split('-');
          dynamicPagePerexArray.splice(1, 0, urlParams['pageNumber'] + '.' + documentPageTitle);
          document.getElementById('dynamicPagePerex').innerText = dynamicPagePerexArray.join(' - ');
        }
      }
      dynamicPageTitleArray = dynamicPageTitleArray.join(' - ');
      const newDocumentTitle = dynamicPageTitleArray + ' - ' + documentTitleLastInArray;

      if (document.title !== newDocumentTitle) {
        document.title = newDocumentTitle;
      }
    }
    //Dynamický title Stop

  }
});
$(document).trigger('STAGE_PAGINATION_ACTIVATE');

if (isMobile.phone || isMobile.tablet) {
  $('body').addClass('is-mobile');
};

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
  window.q.forEach((f) => {
    $(f);
  });
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js